'use client'
import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react'
import { useRouter } from 'next/navigation.js'
import React from 'react'

export const RefreshRouteOnSave = () => {
    const router = useRouter()

    return (
        <PayloadLivePreview
            refresh={() => router.refresh()}
            // The admin panel runs on the same origin as the page, so only accept save messages from it
            serverURL={typeof window === 'undefined' ? process.env.NEXT_PUBLIC_PAYLOAD_URL! : window.location.origin}
        />
    )
}
